// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SortNodes__sortSourceIcon___m6F2y {
    font-size: 11px;
    margin-left: 12px;
    background: none;
}

.SortNodes__sortTargetIcon___am3pe {
    font-size: 12px;
    margin-left: 17px;
    background: linear-gradient(to right, green, rgba(0, 128, 0, 0));
    border-radius: 5px;
    padding: 3px 3px 3px 6px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortSourceIcon": `SortNodes__sortSourceIcon___m6F2y`,
	"sortTargetIcon": `SortNodes__sortTargetIcon___am3pe`
};
module.exports = ___CSS_LOADER_EXPORT___;
